import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import App from '~/App';
import store from '~/utils/redux/store';
import { GlobalStyles } from './components/common';
import { LoadingProvider, WebSocketProvider } from './context';
import reportWebVitals from './reportWebVitals';
import './thirdParties/i18n';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <GlobalStyles>
          <WebSocketProvider>
            <LoadingProvider>
              <App />
            </LoadingProvider>
          </WebSocketProvider>
        </GlobalStyles>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
